import { AnimatePresence, motion } from 'framer-motion'
import { kuiperClassNames, WithTooltip } from '@opallabs/kuiper'
import Button from '@opallabs/kuiper/src/Button'
import { OverrideStyleProps } from '..'
import { animations } from './animations'
import { styles } from './styles'

export interface CarouselArrowsProps {
  carouselWidth: number
  currentIndex: number
  modulesLength: number
  overrideStyles?: OverrideStyleProps
  readOnly: boolean
  onGoBack: () => void
  onGoForward: () => void
}

const iconStyles = {
  height: 12,
  width: 14,
}

export const CarouselArrows: React.FC<CarouselArrowsProps> = ({
  carouselWidth,
  currentIndex,
  overrideStyles,
  modulesLength,
  readOnly,
  onGoBack,
  onGoForward,
}) => {
  const leftArrowDisabled = currentIndex - 1 === -1
  const rightArrowDisabled = currentIndex + 1 >= modulesLength

  return (
    <AnimatePresence>
      <motion.div
        css={styles.getArrowIconsWrapper(
          carouselWidth,
          overrideStyles?.arrowStyles ? overrideStyles.arrowStyles() : {}
        )}
        {...animations.arrowsAnimation}
      >
        <ul css={styles.arrowsWrapper}>
          <WithTooltip
            tooltipOptions={{ position: 'top' }}
            content={
              leftArrowDisabled
                ? 'Currently Viewing First Section'
                : `Go to Section ${currentIndex}`
            }
          >
            <li
              className={kuiperClassNames(
                'modular-carousel-previous',
                readOnly ? 'light-theme' : 'dark-theme',
                leftArrowDisabled ? 'disabled' : ''
              )}
            >
              <Button
                aria-label="Go Back A Section Button"
                icon="arrow-w"
                iconOptions={{ ...iconStyles, ariaMode: 'hidden' }}
                type="nobutton"
                onClick={onGoBack}
              />
            </li>
          </WithTooltip>
          <WithTooltip
            tooltipOptions={{ position: 'top' }}
            content={
              rightArrowDisabled
                ? 'Currently Viewing Last Section'
                : `Go to Section ${currentIndex + 2}`
            }
          >
            <li
              className={kuiperClassNames(
                'modular-carousel-next',
                readOnly ? 'light-theme' : 'dark-theme',
                rightArrowDisabled ? 'disabled' : ''
              )}
            >
              <Button
                aria-label="Go Forward A Section Button"
                icon="arrow-e"
                iconOptions={{ ...iconStyles, ariaMode: 'hidden' }}
                type="nobutton"
                onClick={onGoForward}
              />
            </li>
          </WithTooltip>
        </ul>
      </motion.div>
    </AnimatePresence>
  )
}
